import { render, staticRenderFns } from "./menu-about.vue?vue&type=template&id=2092d7ac&scoped=true&lang=pug"
import script from "./menu-about.vue?vue&type=script&lang=ts"
export * from "./menu-about.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092d7ac",
  null
  
)

export default component.exports